function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export const ChatContext = /*#__PURE__*/React.createContext({
  state: null,
  apiClient: null,
  chatConfiguration: null
});
export const useChatContext = () => React.useContext(ChatContext);
export const useChatConfig = () => {
  const {
    state
  } = useChatContext();
  return state.config;
};
export const withChatContext = Component => props => /*#__PURE__*/React.createElement(ChatContext.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  chatConfiguration: context.chatConfiguration,
  apiClient: context.apiClient,
  chatState: context.state
})));
export default ChatContext;